import { PageHero, CtaSection } from "../components/Sections";
import { GlowLayer } from "../components/Decor";
import Seo from "../components/Seo";
import CountUp from "../components/CountUp";
import { CASE_STUDIES, IMAGES, PAGE_SEO } from "../lib/data";

export default function CaseStudies() {
  return (
    <>
      <Seo {...PAGE_SEO.cases} />
      <PageHero
        crumb="Case Studies"
        image={IMAGES.cases}
        eyebrow="Results & Case Studies"
        title="Real operations. Real"
        accent="measurable results."
        sub="A look at the kinds of challenges we solve and the outcomes our engagements deliver. Client identities are anonymized to protect confidentiality."
      />

      {/* RESULTS BAR */}
      <section id="stats" style={{ position: "relative", overflow: "hidden" }}>
        <GlowLayer />
        <div className="s-inner" style={{ position: "relative" }}>
          <div className="stats-grid fade-up">
            <div className="metric hi">
              <div className="m-num"><CountUp target={99} suffix="%" /></div>
              <div className="m-label">Target Inventory Accuracy</div>
              <div className="m-sub">Post-optimization baseline</div>
            </div>
            <div className="metric">
              <div className="m-num"><CountUp target={35} suffix="%" /></div>
              <div className="m-label">Avg. Labor Cost Reduction</div>
              <div className="m-sub">Through process optimization</div>
            </div>
            <div className="metric">
              <div className="m-num"><CountUp target={2} suffix="x" /></div>
              <div className="m-label">Throughput Gains</div>
              <div className="m-sub">Without adding headcount</div>
            </div>
            <div className="metric">
              <div className="m-num"><CountUp target={30} suffix="/60/90" /></div>
              <div className="m-label">Day Roadmaps</div>
              <div className="m-sub">Prioritized & actionable</div>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY CARDS */}
      <section id="cases">
        <div className="s-inner">
          <div className="fade-up" style={{ textAlign: "center", marginBottom: 48 }}>
            <span className="s-eye">Selected Engagements</span>
            <h2>How we tackle the toughest operational problems</h2>
            <p className="s-lead" style={{ margin: "0 auto" }}>Each engagement starts with the same honest, data-driven approach — and ends with results you can measure.</p>
          </div>
          <div className="case-grid">
            {CASE_STUDIES.map((c, i) => (
              <div className={`case-card fade-up ${i % 2 ? "d1" : ""}`} key={c.title}>
                <span className="case-tag">{c.tag}</span>
                <h3>{c.title}</h3>
                <div className="case-block">
                  <strong>The Challenge</strong>
                  <p>{c.challenge}</p>
                </div>
                <div className="case-block">
                  <strong>What We Did</strong>
                  <p>{c.solution}</p>
                </div>
                <div className="case-results">
                  {c.results.map((r) => (
                    <div key={r.label}>
                      <div className="r-num">{r.num}</div>
                      <div className="r-label">{r.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaSection
        eyebrow="Your Operation Next"
        title="Ready to see results like"
        accent="these?"
        lead="Tell us about your biggest warehouse or systems challenge. We'll show you a practical path to measurable improvement."
      />
    </>
  );
}
